export const SERVICE_COUNTRIES = {
  endpoint: '/countries',
  method: 'get',
  hostel: true,
};
